import type { ReactNode } from "react";
import { appiConfig, authenticationConfig, config } from "config/app-config";
import { AppInsightsProvider, AuthenticationProvider } from "@sdeapps/react-core";
import { RouterProvider } from "react-router";
import { unAuthenticatedRouter, authenticatedRouter } from "routes";
import { SDEAppsSnackbarProvider, SDEAppsThemeProvider } from "providers";
import { Grid } from "@mui/material";
import { BaseErrorPage } from "utils/errorHandling";
import "./App.css";

function App(): ReactNode {
  return (
    <Grid container className="App" sx={{ minHeight: "100vh" }} direction="column" columns={1}>
      <SDEAppsThemeProvider>
        <Grid size="grow">
          <AppInsightsProvider
            onError={BaseErrorPage}
            connectionString={appiConfig.connectionString}
            appVersion={config.appVersion}>
            <SDEAppsSnackbarProvider>
              <AuthenticationProvider
                unauthorizedPage={<RouterProvider router={unAuthenticatedRouter} />}
                config={authenticationConfig}>
                <RouterProvider router={authenticatedRouter} />
              </AuthenticationProvider>
            </SDEAppsSnackbarProvider>
          </AppInsightsProvider>
        </Grid>
      </SDEAppsThemeProvider>
    </Grid>
  );
}

export default App;
